import Vue from 'vue';
import axios from 'axios';
import VueResource from 'vue-resource';
import VModal from 'vue-js-modal'
import './multiselect';

import 'vue-good-table/dist/vue-good-table.css';

import simCardsStatistic from './components/partner/simCardsStatistic.vue'
import VueGoodTable from 'vue-good-table';
import Regulator from "./components/partner/activations/regulator.vue";
import Notifications from 'vue-notification/dist/ssr.js';
import phoneActivationsList from "./components/partner/activations/phoneActivationsList";
import dynamicTopUpStatistic from "./components/monetizeStatistic/dynamicTopUpStatistic";
import Withdrawal from './components/partner/withdrawal/withdrawal';
import BuyNumber from './components/buyNumber'
import PhoneHistory from "./components/client/phoneHistory";
import Timer from "../components/timer/timer.vue";
import GlobalLanguageMixin from '../components/mixins/globalLanguageMixin'
import Profile from './components/profile'
import Calculator from "./components/calculator/calculator";
import Reviews from "./components/reviews/reviews";
import Faq from "./components/faq";
import FormWriteUs from "./components/formWriteUs";
import UserPhoneNumber from "./components/userPhoneNumber/userPhoneNumbers";
import StatisticByPhoneNumberModal from "./components/partner/statisticByPhoneNumberModal";
import WithdrawalReferral from './components/client/withdrawal/referral.vue';
import ConnectionApp from "./components/forms/connectionApp.vue";
import ApiOther from "./components/apiOther.vue";
import PopularActivationsService from "./components/popularActivations/services.vue";
import PopularActivationsCountries from "./components/popularActivations/countries.vue";
import TopUpHistory from "./components/client/topUpHistory.vue";
import MailHistory from "./components/client/mailHistory.vue";
import ProviderStatistic from "./components/client/providerStatistic.vue";
import SetMaxPrice from "./components/client/setMaxPrice.vue";
import BuyBatchMail from "./components/client/buyBatchMail.vue";
import BatchMailHistory from "./components/client/batch/batchMailHistory.vue";
import ApiService from "./components/api/apiService.vue";
import ApiCountry from "./components/api/apiCountry.vue";
import TempMail from "./components/client/tempMail.vue";
import ConnectionAppFormPopup from "./components/forms/connectionAppFormPopup.vue";
import WebPushNotification from "./components/webPushNotification.vue";
import PaymentPage from "./components/payment/paymentPage.vue";
import ClientNotifications from "./components/client/notifications/notifications.vue";
import ClientNotificationModals from "./components/client/notifications/modals/mainModal.vue";
import ClientNotificationBell from "./components/client/notifications/bell.vue";
import CommonStatCard from "./components/monetizeStatistic/commonStatCard.vue";
import AmountStatCard from "./components/monetizeStatistic/amountStatCard.vue";

Vue.mixin(GlobalLanguageMixin);

axios.defaults.baseURL = '/';

axios.interceptors.response.use(
    function (response) {
        if (response.headers['content-type'] === 'text/html; charset=utf-8') {
            location.reload();
        }
        return response;
    },
);

Vue.component('activations-regulator-table', Regulator);
Vue.component('activations-table', phoneActivationsList);
Vue.component('monetize-statistic-chart', dynamicTopUpStatistic);
Vue.component('withdrawal-component', Withdrawal);
Vue.component('buy-number', BuyNumber);
Vue.component('phone-history', PhoneHistory);
Vue.component('mail-history', MailHistory);
Vue.component('timer', Timer);
Vue.component('profile-component', Profile);
Vue.component('faq', Faq);
Vue.component('form-write-us', FormWriteUs);
Vue.component('user-phone-number', UserPhoneNumber);
Vue.component('statistic-by-phone-number-modal', StatisticByPhoneNumberModal);
Vue.component('withdrawal-referral', WithdrawalReferral);
Vue.component('connection-app', ConnectionApp);
Vue.component('popular-services', PopularActivationsService);
Vue.component('popular-countries', PopularActivationsCountries);
Vue.component('top-up-history', TopUpHistory);
Vue.component('provider-statistic', ProviderStatistic);
Vue.component('set-max-price', SetMaxPrice);
Vue.component('buy-batch-mail', BuyBatchMail);
Vue.component('batch-mail-history', BatchMailHistory);
Vue.component('temp-mail', TempMail);
Vue.component('connection-app-form-popup', ConnectionAppFormPopup);
Vue.component('common-stat-card', CommonStatCard);
Vue.component('amount-stat-card', AmountStatCard);


Vue.prototype.$axios = axios;
Vue.use(VueGoodTable);
Vue.use(Notifications);
Vue.use(VueResource);
Vue.use(VModal);
Vue.component('sim-cards-statistic', simCardsStatistic)
Vue.component('calculator-component', Calculator)
Vue.component('reviews-component', Reviews);
Vue.component('api-other', ApiOther);
Vue.component('api-service', ApiService);
Vue.component('api-country', ApiCountry);
new Vue({
    el: '#vue-app',
});

Vue.component('web-push-notification', WebPushNotification);
if (document.querySelector('#web-push-notification')) {
    new Vue({
        el: '#web-push-notification',
    });
}

Vue.component('client-notifications', ClientNotifications);
if (document.querySelector('#client-notifications')) {
    new Vue({
        el: '#client-notifications',
    });
}

Vue.component('client-notification-modals', ClientNotificationModals);
if (document.querySelector('#client-notification-modals')) {
    new Vue({
        el: '#client-notification-modals',
    });
}
Vue.component('client-notification-bell', ClientNotificationBell);
if (document.querySelector('#client-notification-bell')) {
    new Vue({
        el: '#client-notification-bell',
    });
}

new Vue({
    el: '#vue-app-component',
});
if (document.querySelector('#vue-app-component-header')) {
    new Vue({
        el: '#vue-app-component-header',
    });
}
if (document.querySelector('#vue-notification-component')) {
  new Vue({
    el: '#vue-notification-component',
    mounted() {
      window.showNotificationVue = (title, type) => {
        this.$notify({title: title, type: type});
      };
    }
  });
}

Vue.component('payment-page', PaymentPage);
new Vue({
    el: '#payment-page',
});

